import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';
import {
  Label,
  FormWrapper,
  FormField,
  HeadingStyled,
} from 'libs/forms/styles';
import { TextField } from 'libs/forms/views/fieldTypes/text';
import { PasswordField } from 'libs/forms/views/fieldTypes/password';
import FormActionButton from 'libs/forms/views/formActionButton';

import { FooterLabel } from 'apps/signIn/styles';
import { SocialButtons } from 'apps/signIn/views/socialButtons';

import Button from 'components/Button';
import { Divider, TermsConditions } from 'components';
import { WikiWrapper } from 'apps/components';

@withNamespaces()
@observer
export class SignInForm extends React.Component {
  render() {
    const {
      form,
      title,
      handleRequestInvite,
      handleSignIn,
      handleNoAccount,
      handleForgotPassword,
    } = this.props;
    return (
      <WikiWrapper>
        <div className='flex flex-col justify-center items-center flex-grow'>
          <HeadingStyled
            style={{
              margin: '0 auto',
            }}
            isSideBarForm
            size='xmedium'
            variant='primary'
          >
            <Trans>{title}</Trans>
          </HeadingStyled>

          <FormWrapper
            posting={form.posting}
            onSubmit={e => {
              e.preventDefault();
              form.prepare();
              handleSignIn();
            }}
            responsive
            maxResponsive
          >
            <FormField>
              <Label bold>
                <Trans>Username or email </Trans>
              </Label>
              <TextField
                fieldStore={form.fieldStores.get('usernameEmail')}
                responsive
              />
            </FormField>
            <FormField>
              <Label bold>
                <Trans>Password</Trans>
              </Label>
              <PasswordField
                fieldStore={form.fieldStores.get('password')}
                responsive
              />
            </FormField>

            <Button
              onClick={handleForgotPassword}
              appearance='plain'
              variant='secondary'
              size='xsmall'
              style={{ display: 'block' }}
              text={
                <Trans className='text-gray-500'>Forgot your password?</Trans>
              }
            />

            <div className='flex justify-center'>
              <FormActionButton
                formStore={form}
                data-testid='sign-in-button'
                buttonText='Log in'
                buttonTextPosting={form.conf.buttonTextPosting}
                variant='primary'
                style={{
                  margin: '10px auto',
                  background: '#000',
                  borderColor: '#000',
                }}
              />
            </div>
            <Divider text='Or' />
          </FormWrapper>

          <SocialButtons />

          <FooterLabel className='my-4 text-black text-sm'>
            <Trans>Not a member yet?</Trans>
            <a
              className='pl-1 cursor-pointer text-sm'
              onClick={INVITE_MODE ? handleRequestInvite : handleNoAccount}
            >
              {INVITE_MODE ? (
                <Trans className='text-sm'>Request invite</Trans>
              ) : (
                <Trans className='text-sm'>Sign up</Trans>
              )}
            </a>
          </FooterLabel>
          <TermsConditions />
        </div>
      </WikiWrapper>
    );
  }
}

SignInForm.propTypes = {
  form: PropTypes.object,
  title: PropTypes.element,
  handleSignIn: PropTypes.func,
  handleNoAccount: PropTypes.func,
  handleForgotPassword: PropTypes.func,
  handleRequestInvite: PropTypes.func,
};
